/**
* DevExpress Analytics (query-builder\utils\_requestwrapper.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var requestwrapper_1 = require("./requestwrapper");
var serializer_1 = require("../../serializer/serializer");
var _utils_1 = require("../../serializer/_utils");
function wrapGetSelectStatement(callback) {
    return function (connection, queryJSON) {
        if (callback)
            return callback(connection, queryJSON);
        return new requestwrapper_1.RequestWrapper().getSelectStatement(connection, queryJSON);
    };
}
exports.wrapGetSelectStatement = wrapGetSelectStatement;
function wrapRebuildResultSchema(callback) {
    return function (dataSource, queryName, relationsEditing) {
        if (callback)
            return callback(dataSource, queryName, relationsEditing);
        return new requestwrapper_1.RequestWrapper().rebuildResultSchema(dataSource, queryName, relationsEditing);
    };
}
exports.wrapRebuildResultSchema = wrapRebuildResultSchema;
function serializeDataConnection(connection) {
    var serializer = new serializer_1.ModelSerializer();
    var data = { 'DataConnection': serializer.serialize(connection) };
    if (!!connection.options)
        _utils_1.extend(data, { 'ConnectionOptions': serializer.serialize(connection.options) });
    return JSON.stringify(data);
}
exports.serializeDataConnection = serializeDataConnection;
